import axios from 'axios';
import React, { useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const DeleteClientModel = ({show, close, clientId}) => {

  const DeleteClientToast = () => {
    toast.success("Deleted Successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose:1000,
      toastId: "delete-success"
    });
  };

  const DeleteClientData = async (e) => {
    e.preventDefault();
    let payload = {
      clientId: clientId,
    };
    try {
      await axios.post(
        process.env.REACT_APP_BASE_URL + "/client/deleteClient",payload )
        .then((res) => {
          DeleteClientToast()
          setTimeout(() => {
            close()
          }, 1000)
        })
        .catch((error) => {
          console.log("error", error);
        })
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <>
     <ToastContainer />
      <Modal show={show} onHide={close} centered backdrop="static" keyboard={false}>
        <Modal.Header closeButton style={{ color: "black" }}>
          <Modal.Title><h5>Delete Employee</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body className='py-4'>
          <p style={{ color: "black", fontSize: "15px", margin: '0px' }}>
            Are you sure you want to delete this Records?👎
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className='secondaryBtn' onClick={close}>
            Cancel
          </Button>
          <Button variant="danger"
            onClick={(e) => DeleteClientData(e)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
